import { createSlice } from "@reduxjs/toolkit";
import {
  loginBuilder,
  logoutBuilder,
  refreshBuilder,
  getAdminUserInfoBuilder,
} from "./builder";

const initialState = {
  email: "",
  loggedIn: null,
  error: null,
  token: null,
  loginPending: false,
  getAdminUserInfoPending: false,
  user: null,
};

export const authSlice = createSlice({
  name: "authInfo",
  initialState,
  reducers: {
    setLoggedIn: (state, { payload }) => {
      state.loggedIn = payload.loggedIn;
    },
    setToken: (state, { payload }) => {
      state.token = payload;
    },
  },
  extraReducers: (builder) => {
    loginBuilder(builder);
    refreshBuilder(builder);
    logoutBuilder(builder);
    getAdminUserInfoBuilder(builder);

    builder.addCase("logout", () => ({
      ...initialState,
      loggedIn: false,
      user: null,
    }));
  },
});

export const { setLoggedIn, setToken } = authSlice.actions;

export const selectAdminUserInfo = (state) => state.authInfo;
export const selectLoggedIn = (state) => state.authInfo.loggedIn;
export const selectLoginPending = (state) => state.authInfo.loginPending;
export const selectGetAdminUserInfoPending = (state) =>
  state.authInfo.getAdminUserInfoPending;
export const selectUser = (state) => state.authInfo.user;
export const selectToken = (state) => state.authInfo.token;

export default authSlice.reducer;
